import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import ErrorBoundary from '@rhino/shared/components/errorhandling/ErrorBoundary';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { SputnikTheme } from '@rhino/shared/themes/sputnik';

import { Provider } from 'react-redux';
import {store} from '../services/redux/store';
import ErrorProvider from '@rhino/shared/contexts/ErrorContext';
import { SnackbarProvider } from 'notistack';
import { AppDimensionsProvider } from '@rhino/shared/contexts/AppDimensionsContext';

// Register orbotnik-specific context hooks for shared PreferenceControls
import { registerContextHooks } from '@rhino/shared/components/administration/preferencecontrols/PreferenceControls';
import {
  useNebulonTileAttributesContext, useNebulonTileSputnikDeviceStatusContext,
  useNebulonRoomAttributesContext,
} from '../contexts/administration/AdminContexts';

registerContextHooks({
  nebulonTileAttributes: useNebulonTileAttributesContext,
  nebulonTileSputnikDeviceStatus: useNebulonTileSputnikDeviceStatusContext,
  nebulonRoomAttributes: useNebulonRoomAttributesContext,
});

createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider theme={SputnikTheme}>
            <CssBaseline enableColorScheme />      
              <ErrorProvider>   
                <AppDimensionsProvider>
                  <SnackbarProvider maxSnack={3}>
                    <App />
                  </SnackbarProvider>
                </AppDimensionsProvider>
              </ErrorProvider>
          </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  // </React.StrictMode>
);
